// ページ内アンカーリンクのスクロールエフェクト // Scrolling effect for anchor links within the page
// ヘッダーが固定の場合はheaderHightにヘッダーの高さを設定(PC/SP要設定) // Set header height to headerHight if header is fixed (PC/SP setting required)
jQuery(function ($) {
  var headerHeight = $("header").innerHeight() + 10; // ヘッダー追従の場合 // if header following
  $('a[href^="#"]').click(function () {
    var href = $(this).attr("href");
    var target = $(href == "#" || href == "" ? "html" : href);
    if (target.length > 0) {
      var position = target.offset().top - headerHeight;
      $("html, body").animate({ scrollTop: position }, 550, "swing");
      return false;
    }
  });
});

// ドロワーメニュー // Drawer menu
jQuery(function ($) {
  if ($("#toggle").length > 0) {
    $("#toggle").click(function () {
      $(this).toggleClass("toggle_active");
      $("#drawer_layer").fadeToggle();
      $("body").toggleClass("drawer_open");

      if ($(this).hasClass("toggle_active")) {
        $("nav").addClass("is_open");
        $("nav").removeClass("is_close");
      } else {
        $("nav").removeClass("is_open");
        $("nav").addClass("is_close");
      }
    });

    $("#drawer_layer").click(function () {
      $(this).fadeOut();
      $("#toggle").removeClass("toggle_active");
      $("body").removeClass("drawer_open");
      $("nav").removeClass("is_open");
      $("nav").addClass("is_close");
    });

    // エリア内リンク用 // For links within an area
    $("nav a").click(function () {
      // if (window.innerWidth <= 768) {
      if ($("#toggle:visible").length > 0) {
        $("#toggle").click();
      }
    });
  }
});

// タブ
jQuery(function ($) {
  if ($(".js-tab-item").length > 0) {
    $(".js-tab-item").click(function () {
      $(".js-tab-item").removeClass("is-active");
      $(this).addClass("is-active");
      $(".js-tab-content").removeClass("is-active");
      $(".js-tab-content").eq($(this).index()).addClass("is-active");
    });
  }
});

// スライダー
jQuery(function ($) {
  const caseSwiper = new Swiper(".js-case-slider", {
    loop: true,
    slidesPerView: "auto",
    speed: 8000,
    spaceBetween: 8,
    allowTouchMove: false,
    autoplay: {
      delay: 0,
    },
  });

  const caseReverseSwiper = new Swiper(".js-case-slider--reverse", {
    loop: true,
    slidesPerView: "auto",
    speed: 16000,
    spaceBetween: 8,
    allowTouchMove: false,
    autoplay: {
      delay: 0,
      // reverseDirection: true,
    },
    on: {
      init: function() {
        // Safari対策: 初期化後に一度停止してから再開
        setTimeout(() => {
          this.autoplay.stop();
          this.autoplay.start();
        }, 100);
      }
    }
  });

  // const gallerySwiper = new Swiper(".js-gallery-slider", {
  //   loop: true,
  //   slidesPerView: "auto",
  //   speed: 10000,
  //   spaceBetween: 20,
  //   allowTouchMove: false,
  //   autoplay: {
  //     delay: 0,
  //   },
  // });
});


// サービスサイドバー
jQuery(function ($) {
  var $sidebarLinks = $(".c-sidebarNav__link");
  var $sections = $sidebarLinks.map(function () {
    var target = $($(this).attr("href"));
    if (target.length) {
      return target;
    }
  });

  // サイドバーリンククリック時のスムーススクロール
  // $sidebarLinks.click(function(e) {
  //   e.preventDefault();
  //   var href = $(this).attr("href");
  //   var target = $(href);
  //   if (target.length > 0) {
  //     var headerHeight = 80;
  //     var position = target.offset().top - headerHeight;
  //     $("html, body").animate({scrollTop: position}, 550, "swing");
  //   }
  // });

  $(window).scroll( function () {
    var scrollTop = $(this).scrollTop();
    var offset = 150;
    var currentSection = $sections.map(function () {
      if ($(this).offset().top - offset <= scrollTop) {
        return this;
      }
    });
    currentSection = currentSection[currentSection.length - 1];
    var id = currentSection && currentSection.length ? currentSection.attr("id") : "";
    if (id) {
      $sidebarLinks.removeClass("is-active");
      $sidebarLinks.filter('[href="#' + id + '"]').addClass("is-active");
    }
  });
});

// アコーディオン
jQuery(function ($) {
  // アコーディオンの起動 // Activate the accordion
  $(".js-ac-toggle").click(function () {
    $(this).next(".js-ac-contents").slideToggle(200);
    $(this).toggleClass("is-open");
  });

   // アコーディオンの起動 // Activate the accordion
   $(".js-ac-toggle-wrap").click(function () {
    $(this).find(".js-ac-contents-child").slideToggle(200);
    $(this).toggleClass("is-open");
  });
});



// ヘッダー固定
jQuery(function ($) {
	if ( $('.js-header-fixed').length > 0 ) {
		$(window).scroll(function() {
			var fvHeight = $('.js-header-fixed').outerHeight();
			var scrollTop = $(window).scrollTop();
			
			if (scrollTop > fvHeight) {
				$('.l-header').addClass('is-fixed');
			} else {
				$('.l-header').removeClass('is-fixed');
			}
		});
	}
});


// スクロールヒント
jQuery(function ($) {
  if ($(".js-scroll").length > 0) {
    new ScrollHint(".js-scroll");
  }
});

// ヘッダーアコーディオン
jQuery(function($) {
	$('.l-header-nav__item--parent > .l-header-nav__parent').click(function(e) {
		if ($('.l-header-nav').hasClass('is_open')) {
			e.preventDefault();
			var $subMenu = $(this).next('.l-header-nav__sub');
			$(this).parent().toggleClass('is_active');
			$subMenu.stop(true, false).slideToggle(200);
		}
	});
});


const el = document.querySelector('.js-recommend-swiper');
if (el) {
  new Swiper(el, {
    slidesPerView: 4,
    spaceBetween: 16,
    navigation: {
      prevEl: '.js-recommend-prev',
      nextEl: '.js-recommend-next',
    },
    breakpoints: {
      0: { slidesPerView: 1, spaceBetween: 12 },
      640: { slidesPerView: 2, spaceBetween: 16 },
      1024: { slidesPerView: 4, spaceBetween: 16 },
    },
  });
}


// Contact Form 7 ラジオボタンのURLパラメーター連携
jQuery(function($) {
	// ラジオボタンを選択する関数
	function selectRadioByParam() {
		// /contact/ページでのみ実行
		if ($('.p-contact').length > 0 && $('.p-form__radio').length > 0) {
			// URLパラメーターを取得
			var urlParams = new URLSearchParams(window.location.search);
			var typeParam = urlParams.get('type');
			
			// ラジオボタンのリストを取得
			var $radioItems = $('.p-form__radio').find('input[type="radio"]');
			
			if ($radioItems.length >= 5) {
				var targetIndex = -1;
				
				// パラメーターに応じて選択するインデックスを決定
        if (typeParam === 'askul') {
					targetIndex = 2;
				}
				if (typeParam === 'entry') {
					targetIndex = 3;
				}
				// 対応するラジオボタンを選択
				if (targetIndex >= 0 && targetIndex < $radioItems.length) {
					$radioItems.eq(targetIndex).prop('checked', true).trigger('change');
				}
			}
		}
	}
	
	// ページ読み込み時に実行
	selectRadioByParam();
	
	// Contact Form 7がAJAXで読み込まれた場合にも対応
	$(document).on('wpcf7mailsent wpcf7invalid wpcf7spam wpcf7mailfailed wpcf7submit', function() {
		// フォーム送信後、リセットされた場合に再実行
		setTimeout(selectRadioByParam, 100);
	});
	
	// Contact Form 7のフォームが読み込まれた時にも実行
	$(document).on('DOMContentLoaded', selectRadioByParam);
	
	// 少し遅延して実行（フォームが完全に読み込まれるまで待つ）
	setTimeout(selectRadioByParam, 500);
});
